import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { SUPPLIER_RESET_TO_DRAFT } from "../graphql";

const RejectedActionView = ({ supplier }) => {
  const [resetDraft, resetDraftRes] = useMutation(SUPPLIER_RESET_TO_DRAFT, {
    variables: { id: supplier.id },
    onCompleted() {
      Alert("success", "Supplier has been reset to draft successfully.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_SUPPLIER"],
    awaitRefetchQueries: true,
  });

  function resetHandler() {
    if (
      window.confirm(
        "Are you sure you want to reset this supplier to draft? Once reset, all review data will be lost archived and you will need to re-submit the supplier for review.",
      )
    ) {
      resetDraft();
    }
  }

  return (
    <div>
      <div>Supplier has been rejected.</div>
      <div className="mt-1">
        <Button onClick={resetHandler} loading={resetDraftRes.loading}>
          Reset to Draft
        </Button>
      </div>
    </div>
  );
};

export default RejectedActionView;
